import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import type { CustomField } from '@/lib/api/types/customField';
import { formatCurrency } from '@/lib/utils/common/formatCurrency';
import { isFiniteNumber } from '@/lib/utils/common/number';

export const CurrencyCell = ({
  value,
  currencyUnit,
}: { value?: number } & Pick<CustomField, 'currencyUnit'>) =>
  isFiniteNumber(value) && <OverflowTooltip>{formatCurrency(value, currencyUnit)}</OverflowTooltip>;
